// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table styles for VFH application tables */
/* Using specific class names to avoid conflicts with coc-styles-designSystem-bundle.css */

.vfh-table-header-cell {
  font-weight: 700 !important; /* Bold text */
  background-color: #f5f5f5 !important; /* Material-UI grey.100 - override theme */
  color: #000 !important; /* Ensure text is black, not light grey */
  border-bottom: 1px solid rgba(0, 0, 0, 0.12); /* divider color */
  padding-top: 12px; /* py: 1.5 */
  padding-bottom: 12px; /* py: 1.5 */
  padding-left: 16px; /* px: 2 */
  padding-right: 16px; /* px: 2 */
  white-space: nowrap;
}

/* Ensure Typography components inside header cells are also black and bold */
.vfh-table-header-cell .MuiTypography-root {
  color: #000 !important;
  font-weight: 700 !important;
}

.vfh-table-body-cell {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12); /* divider color */
  padding-top: 12px; /* py: 1.5 for md */
  padding-bottom: 12px; /* py: 1.5 for md */
  padding-left: 16px; /* px: 2 */
  padding-right: 16px; /* px: 2 */
  vertical-align: middle;
}

/* Responsive padding for body cells */
@media (max-width: 599.95px) {
  .vfh-table-body-cell {
    padding-top: 20px; /* py: 2.5 for xs */
    padding-bottom: 20px; /* py: 2.5 for xs */
  }
}

@media (min-width: 600px) and (max-width: 899.95px) {
  .vfh-table-body-cell {
    padding-top: 16px; /* py: 2 for sm */
    padding-bottom: 16px; /* py: 2 for sm */
  }
}

@media (min-width: 900px) {
  .vfh-table-body-cell {
    padding-top: 12px; /* py: 1.5 for md */
    padding-bottom: 12px; /* py: 1.5 for md */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/tableStyles.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,0FAA0F;;AAE1F;EACE,2BAA2B,EAAE,cAAc;EAC3C,oCAAoC,EAAE,0CAA0C;EAChF,sBAAsB,EAAE,yCAAyC;EACjE,4CAA4C,EAAE,kBAAkB;EAChE,iBAAiB,EAAE,YAAY;EAC/B,oBAAoB,EAAE,YAAY;EAClC,kBAAkB,EAAE,UAAU;EAC9B,mBAAmB,EAAE,UAAU;EAC/B,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C,EAAE,kBAAkB;EAChE,iBAAiB,EAAE,mBAAmB;EACtC,oBAAoB,EAAE,mBAAmB;EACzC,kBAAkB,EAAE,UAAU;EAC9B,mBAAmB,EAAE,UAAU;EAC/B,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE;IACE,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;EAC3C;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,iBAAiB;IACpC,oBAAoB,EAAE,iBAAiB;EACzC;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;EAC3C;AACF","sourcesContent":["/* Table styles for VFH application tables */\n/* Using specific class names to avoid conflicts with coc-styles-designSystem-bundle.css */\n\n.vfh-table-header-cell {\n  font-weight: 700 !important; /* Bold text */\n  background-color: #f5f5f5 !important; /* Material-UI grey.100 - override theme */\n  color: #000 !important; /* Ensure text is black, not light grey */\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12); /* divider color */\n  padding-top: 12px; /* py: 1.5 */\n  padding-bottom: 12px; /* py: 1.5 */\n  padding-left: 16px; /* px: 2 */\n  padding-right: 16px; /* px: 2 */\n  white-space: nowrap;\n}\n\n/* Ensure Typography components inside header cells are also black and bold */\n.vfh-table-header-cell .MuiTypography-root {\n  color: #000 !important;\n  font-weight: 700 !important;\n}\n\n.vfh-table-body-cell {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12); /* divider color */\n  padding-top: 12px; /* py: 1.5 for md */\n  padding-bottom: 12px; /* py: 1.5 for md */\n  padding-left: 16px; /* px: 2 */\n  padding-right: 16px; /* px: 2 */\n  vertical-align: middle;\n}\n\n/* Responsive padding for body cells */\n@media (max-width: 599.95px) {\n  .vfh-table-body-cell {\n    padding-top: 20px; /* py: 2.5 for xs */\n    padding-bottom: 20px; /* py: 2.5 for xs */\n  }\n}\n\n@media (min-width: 600px) and (max-width: 899.95px) {\n  .vfh-table-body-cell {\n    padding-top: 16px; /* py: 2 for sm */\n    padding-bottom: 16px; /* py: 2 for sm */\n  }\n}\n\n@media (min-width: 900px) {\n  .vfh-table-body-cell {\n    padding-top: 12px; /* py: 1.5 for md */\n    padding-bottom: 12px; /* py: 1.5 for md */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
